export const RELEASE_SHOW_INSTANT_DEPOSIT = 'release-show-instant-deposit';
export const BANKING_UI_MAINTENANCE_BANNER = 'banking-ui-maintenance-banner';
export const RELEASE_PRE_FILL_DEPOSIT_AMOUNT_IN_FIRST_DEPOSIT =
  'release-pre-fill-deposit-amount-in-case-its-a-first-deposit';
export const RELEASE_PREVENT_SUBMIT_BANKING_APPLICATION_WITH_PROHIBITED_BUSINESS_VERTICAL =
  'release-prevent-submit-banking-application-with-prohibited-business-vertical';
export const RELEASE_WHATS_NEW_SECTION = 'release-whats-new-section';
export const RELEASE_PREVENT_BANNER_COVER_UP_TEXT = 'release-prevent-banner-cover-up-text';

export const RELEASE_INVOICING_FEATURE_ANNOUNCEMENT_BANNER =
  'release-invoicing-feature-announcement-banner';
export const RELEASE_DISABLE_WIRE_TRANSACTION_TYPE_IN_ZB_APP =
  'release-disable-wire-transaction-type-in-zb-app';
export const RELEASE_SURVEY_BANKING_APPLICATION_FLOW = 'release-survey-banking-application-flow';
export const RELEASE_TAX_SERVICES_BANNER = 'release-tax-services-banner';
export const RELEASE_BANKING_UPSELL_PAGE_AND_NON_QUALIFIED_PAGE_TO_INCLUDE_BLUEVINE = {
  FLAG: 'release-banking-upsell-and-non-qualified-page-to-include-bluevine-a-b-test',
  VARIATIONS: {
    VERSION_A: 'Version A',
    VERSION_B: 'Version B',
    VERSION_C: 'Version C',
    CONTROL: 'Control'
  }
};
export const ENABLE_FUNDBOX_QUALIFIED_LIST_CONTROL_WIDGET =
  'enable-fundbox-qualified-list-control-widget';

export const CONFIGURE_BANKING_CARDS_OFFERS = 'configure-banking-card-offers';
export const RELEASE_THREAD_BANK_COMPLIANCE = 'release-thread-bank-compliance';
export const HIGH_RISK_UNIT_THREAD_BANK_CUSTOMERS = 'high-risk-unit-thread-bank-customers';
export const ZB_BANKING_SUNSET_PH3 = 'zb-banking-sunset-ph3';
export const ZB_BANKING_SUNSET_PH3_HIGH_RISK_CUSTOMERS =
  'zb-banking-sunset-ph3-high-risk-customers';
